import { apis, chttp } from '@/libs/interfaces';
import Wx from '@/libs/app/weixin';

export default {
  methods: {
    async getDefault(callback) {
      this.isLoading = true
      try {
        const params = {
          openid: this.openid,
          unionid: this.unionid,
        };
        const res = await chttp.get(apis.photo_pagv3, { params })
        this.hasPrivilege = res.data.privilege
        this.parentParams = res.data.package.all.novip
        if (callback) {
          callback();
        }
      } finally {
        this.isLoading = false
      }
    },
    uploadPhoto() { // 上传照片
      const self = this;
      const num = this.uploadedPics.length;
      if (num >= this.imgnum) return
      Wx.chooseImage(this.imgnum - num, (ids) => {
        self.imageUpload(ids);
      });
    },
    imageUpload(ids) { // 上传照片
      this.$loading.open('照片上传中');
      const params = {
        media_id: ids, // 直接使用 ids
      };
      chttp.post('/vod/photo/upload?uploadImg=up', params)
        .then((res) => {
          this.uploadedPics.push(...res.data); // 使用扩展运算符直接推入数组
          this.$loading.close();
        });
    },
    async handleSend(fromType) { // 发送照片
      fromType = `${fromType}_${this.photoPath.entrance}` || `photoT_${this.photoPath.entrance}`

      if (!this.hasPrivilege) {
        return this.buyPrivilege();
      }

      const sendMap = {
        1: this.sendPhotoPng,
        2: this.sendPhotoPngs,
        3: this.sendPhotos
      };

      const sendFn = sendMap[this.photoPath.id];
      if (sendFn) {
        await sendFn(fromType);
      }
    },

    buyPrivilege(callback) { // 购买套餐
      // 当entrance包含play-search-banner时，设置为play-search-banner
      const entrance = this.entrance && this.entrance.includes('play-search-banner')
        ? 'play-search-banner'
        : this.entrance;
      this.$store.dispatch('wxpay', {
        params: {
          unionid: this.unionid,
          openid: this.openid,
          pkg_id: this.parentParams.pkg_id,
          entrance,
        },
        wxUrl: apis.privilegeWxpay,
        elseData: {
          callback: () => {
            this.getDefault();
            if (callback) {
              callback()
            }
          },
          // 为role3用户添加支付取消回调
          cancelcallback: () => {
            if (this.$store.state.role === 'role3') {
              // 互斥逻辑：关闭可能存在的VIP待支付弹窗
              this.$store.commit('SET_SHOW_PAY_TOAST', false);

              // 设置娱乐支付待支付信息
              this.$store.commit('SET_PENDING_PAYMENT', {
                type: 'entertainment', // 标识为娱乐支付类型
              });

              // 显示娱乐支付待支付弹窗
              this.$store.commit('SET_SHOW_PAY_TOAST', true);
            }
          }
        }
      });
    },

    async sendPhotos(fromType) { // pag版发送照片
      if (!this.uploadedPics.length) {
        return this.$messageBox.alert('请上传图片!', '', { cancelButtonText: '确定' });
      }

      const params = {
        openid: this.openid,
        unionid: this.unionid,
        content_text: '全场的所有人，暴富！暴富！暴富！',
        pic_list: JSON.stringify(this.uploadedPics),
        pay_enter: fromType || this.$route.name,
        from_type: fromType || this.$route.name,
        isPag: this.photoPag,
        topicId: 2024090301,
      };

      await this.sendPhotoRequest(apis.photo_pag_free, params);
    },

    async sendPhotoPngs(fromType) { // png版多张发送照片
      if (!this.uploadedPics.length) {
        return this.$messageBox.alert('请上传图片!', '', { cancelButtonText: '确定' });
      }

      const params = {
        openid: this.openid,
        unionid: this.unionid,
        content_text: '麦霸一开嗓，财富跟着涨！',
        pic_list: JSON.stringify(this.uploadedPics),
        natant_url: 'https://qncweb-back1.ktvsky.com/common-web/operation_cms/1625726248378f9fd4c7f5da6f379ea4cdf5c6c9e96b1.png',
        pay_enter: fromType,
        speak: '',
        from_type: fromType,
      };

      await this.sendPhotoRequest(apis.pngSendPhotos, params);
    },

    async sendPhotoPng(fromType) { // png版单张发照片
      if (!this.uploadedPics.length) {
        return this.$messageBox.alert('请上传图片!', '', { cancelButtonText: '确定' });
      }

      const params = {
        openid: this.openid,
        unionid: this.unionid,
        content_text: '麦霸一开嗓，财富跟着涨！',
        img_url: this.uploadedPics[0],
        pay_enter: fromType,
        from_type: fromType,
      };

      await this.sendPhotoRequest(apis.pngSendPhoto, params);
    },

    async sendPhotoRequest(api, params) {
      const res = await chttp.post(api, params);
      if (res.errcode === 200) {
        this.uploadedPics = [];
        this.$toast({ toastTxt: '<span style="white-space:nowrap">发送成功，请看大屏幕</span>' });
      }
    }
  },
};
